import React from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { isDarkAtom } from '../../../atoms/shared/uiAtoms';

interface CreateCharacterCardProps {
  onClick: () => void;
}

/**
 * 创建角色卡按钮组件
 */
export const CreateCharacterCard: React.FC<CreateCharacterCardProps> = ({ onClick }) => {
  const { t } = useTranslation(['v3/character']);
  const [isDark] = useAtom(isDarkAtom);

  return (
    <div
      onClick={onClick}
      className={`
        p-4 rounded-xl border-2 border-dashed cursor-pointer transition-all duration-200
        flex flex-col items-center justify-center min-h-[200px]
        ${isDark 
          ? 'border-ios-dark-separator bg-ios-dark-gray6 hover:bg-ios-dark-gray5 hover:border-ios-dark-blue' 
          : 'border-ios-light-separator bg-white hover:bg-blue-50 hover:border-blue-300'
        }
        ${isDark ? 'shadow-ios-dark' : 'shadow-ios-light'}
      `}
    >
      {/* 加号图标 */}
      <div className={`
        w-16 h-16 rounded-full flex items-center justify-center mb-4 transition-colors
        ${isDark 
          ? 'bg-ios-dark-gray4 text-ios-dark-secondary-label' 
          : 'bg-gray-100 text-gray-500'
        }
      `}>
        <Plus size={32} />
      </div>

      {/* 文字说明 */}
      <h3 className={`font-semibold text-lg mb-2 ${isDark ? 'text-ios-dark-label' : 'text-ios-light-label'}`}>
        {t('v3/character:createCharacter', '创建角色卡')}
      </h3>
      
      <p className={`text-sm text-center ${isDark ? 'text-ios-dark-secondary-label' : 'text-ios-light-secondary-label'}`}>
        {t('v3/character:createCharacterDescription', '点击创建你的专属AI角色')}
      </p>
    </div>
  );
};
